module.exports = __webpack_public_path__ + "de309d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/two-rows-line-list.svg
// module id = 2371
// module chunks = 16 32